import { Component, inject, Input } from '@angular/core';
import { Portals } from '@qwyk/models';
import { CustomFieldsFacade } from '../../+state/custom-fields.facade';
import { AuthenticationFacade } from '@qwyk/portals/authentication';

@Component({
    selector: 'qwyk-custom-fields-view',
    templateUrl: './custom-fields-view.component.html',
    styleUrls: ['./custom-fields-view.component.scss'],
})
export class CustomFieldsViewComponent {

    private readonly auth = inject(AuthenticationFacade);
    private readonly customFields = inject(CustomFieldsFacade);

    public dateFormat$ = this.auth.dateFormat$;
    public loading$ = this.customFields.loading$;
    public error$ = this.customFields.error$;
    public customFields$ = this.customFields.allCustomFields$;

    private _parent!: Portals.ParentEntity;

    @Input()
    public set parent(parent: Portals.ParentEntity) {
        this._parent = parent;
        this.onParentChanged(parent);
    }
    @Input() columnSize = 'col-12 col-md-3';

    private onParentChanged(parent: Portals.ParentEntity) {
        this.customFields.init(parent, {});
    }
}
